/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { AcademicRankDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns academic ranks for the aid model
 * @summary Get academic ranks
 */
export const getAcademicRanks = (
  userId: string,
  aidModelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AcademicRankDto[]>(
    {
      url: `/api/${userId}/aid-models/${aidModelId}/academic-ranks`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAcademicRanksQueryKey = (
  userId: string,
  aidModelId: number
) => {
  return [`/api/${userId}/aid-models/${aidModelId}/academic-ranks`] as const;
};

export const getGetAcademicRanksQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcademicRanks>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  aidModelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcademicRanks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAcademicRanksQueryKey(userId, aidModelId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcademicRanks>>
  > = ({ signal }) =>
    getAcademicRanks(userId, aidModelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && aidModelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcademicRanks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAcademicRanksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcademicRanks>>
>;
export type GetAcademicRanksQueryError = ErrorType<unknown>;

export function useGetAcademicRanks<
  TData = Awaited<ReturnType<typeof getAcademicRanks>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  aidModelId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcademicRanks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcademicRanks>>,
          TError,
          Awaited<ReturnType<typeof getAcademicRanks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAcademicRanks<
  TData = Awaited<ReturnType<typeof getAcademicRanks>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  aidModelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcademicRanks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcademicRanks>>,
          TError,
          Awaited<ReturnType<typeof getAcademicRanks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAcademicRanks<
  TData = Awaited<ReturnType<typeof getAcademicRanks>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  aidModelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcademicRanks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get academic ranks
 */

export function useGetAcademicRanks<
  TData = Awaited<ReturnType<typeof getAcademicRanks>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  aidModelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcademicRanks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAcademicRanksQueryOptions(
    userId,
    aidModelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
